import React from 'react';

import PropTypes from 'prop-types';

export type Subscription = {
  daysRemaining: number;
  endDate: string;
  offeringCategory: string;
  offeringCategoryName: string;
  offeringCategoryRanking: number;
  offeringExternalKey: string;
  offeringName: string;
  status: string;
  type: string;
};

export type User = {
  id: string;
  email: string;
  analyticsId?: string | null;
};

export type BannerMessage = {
  text: React.ReactNode;
  daysLeft: number;
};

export const subscriptionPropType = PropTypes.shape({
  daysRemaining: PropTypes.number.isRequired,
  endDate: PropTypes.string.isRequired,
  offeringCategory: PropTypes.string.isRequired,
  offeringCategoryName: PropTypes.string.isRequired,
  offeringCategoryRanking: PropTypes.number.isRequired,
  offeringExternalKey: PropTypes.string.isRequired,
  offeringName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export const userPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  analyticsId: PropTypes.string,
});

export const bannerMessagePropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  daysLeft: PropTypes.number.isRequired,
});
